import { Store, StoreConfig } from "@datorama/akita";
import { User } from "../../models/interfaces/auth.interface";
import { createInitialSessionState, createSession, SessionState } from "./session.model";

@StoreConfig({ name: 'session', resettable: true})
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createInitialSessionState());
  }

  login(data: User) {
    const user = createSession(data);
    this.update({user: user});
  }

  logout() {
    this.update(createInitialSessionState);
  }
}

export const sessionStore = new SessionStore();